const ChevronLeft = () => (
  <svg focusable={false} viewBox='0 0 24 24'>
    <path
      fill='none'
      fillRule='evenodd'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M15 18l-6-6 6-6'
    />
  </svg>
);

export default ChevronLeft;
